"use client"

import { Navbar } from "@/components/Navbar"
import { Footer } from "@/components/Footer"

export function BlogCardSkeleton() {
  return (
    <div className="bg-white border border-border rounded-xl sm:rounded-2xl p-5 sm:p-6 animate-pulse">
      {/* Arrow skeleton */}
      <div className="flex justify-end mb-3 sm:mb-4">
        <div className="h-5 w-5 bg-bg-alt rounded" />
      </div>

      {/* Title skeleton */}
      <div className="h-6 sm:h-7 bg-bg-alt rounded mb-2 w-3/4" />

      {/* Date skeleton */}
      <div className="h-4 w-24 bg-bg-alt rounded mb-3 sm:mb-4" />

      {/* Excerpt skeleton */}
      <div className="space-y-2 mb-4 sm:mb-6">
        <div className="h-4 bg-bg-alt rounded w-full" />
        <div className="h-4 bg-bg-alt rounded w-5/6" />
        <div className="h-4 bg-bg-alt rounded w-4/6" />
      </div>

      {/* Tags skeleton */}
      <div className="flex gap-2">
        <div className="h-6 w-16 bg-bg-alt rounded-full" />
        <div className="h-6 w-20 bg-bg-alt rounded-full" />
      </div>
    </div>
  )
}

export function BlogListSkeleton() {
  return (
    <main className="min-h-screen bg-bg">
      <Navbar />

      {/* Hero skeleton */}
      <section className="pt-24 md:pt-32 pb-8 md:pb-12 bg-gradient-to-b from-bg to-bg-alt">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="h-4 w-20 bg-bg-alt rounded mb-3 sm:mb-4 animate-pulse" />
            <div className="h-10 sm:h-12 md:h-14 bg-bg-alt rounded mb-4 sm:mb-6 w-1/3 animate-pulse" />
            <div className="h-5 sm:h-6 bg-bg-alt rounded w-2/3 animate-pulse" />
          </div>
        </div>
      </section>

      {/* Search skeleton */}
      <section className="py-6 sm:py-8">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-4 sm:mb-6">
            <div className="h-10 sm:h-12 max-w-xl bg-bg-alt rounded-lg sm:rounded-xl animate-pulse" />
          </div>

          {/* Filter skeleton */}
          <div className="flex flex-wrap gap-2">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="h-8 sm:h-9 w-16 sm:w-20 bg-bg-alt rounded-full animate-pulse" />
            ))}
          </div>
        </div>
      </section>

      {/* Grid skeleton */}
      <section className="pb-16 sm:pb-20">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <BlogCardSkeleton key={i} />
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  )
}
